export default {
  update: (key, value, path = null, preserveQs = false) => {
    let uri = window.location.href;
    let preservedQs;

    // use DOM to parse uri
    const a = document.createElement('a');

    if (preserveQs) {
      a.href = uri;
      if (a.search) {
        preservedQs = a.search;
      }
    }

    if (path) {
      uri = `${window.location.origin}${path}`;
    }

    a.href = uri;

    if (preservedQs) {
      a.search = preservedQs;
    }

    if (!a.search) {
      a.search = `?${key}=${value}`;
    } else {
      // eslint-disable-next-line security-node/non-literal-reg-expr
      const regex = new RegExp(key + '((?:\\[[^\\]]*\\])?)(=|$)(.*)');
      let qs,
        qsLength,
        keyFound = false;

      qs = a.search.replace(/^\?/, '').split(/&(?:amp;)?/);
      qsLength = qs.length;

      while (qsLength > 0) {
        qsLength--;

        if (!qs[qsLength]) {
          qs.splice(qsLength, 1);
          continue;
        }

        if (regex.test(qs[qsLength])) {
          qs[qsLength] = qs[qsLength].replace(regex, key + '$1') + '=' + value;
          keyFound = true;
        }
      }

      // If we haven't replaced any occurrences above, add the new parameter and value
      if (!keyFound) {
        qs.push(`${key}=${value}`);
      }

      // Set the new query string
      a.search = `?${qs.join('&')}`;
    }

    return a.href;
  },

  getParameter: (paramName) => {
    const name = paramName.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    // eslint-disable-next-line security-node/non-literal-reg-expr
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },
};
